import { render } from "./DeleteConfirmModal.vue?vue&type=template&id=0c460430&scoped=true"
import script from "./DeleteConfirmModal.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmModal.vue?vue&type=script&lang=js"

import "./DeleteConfirmModal.vue?vue&type=style&index=0&id=0c460430&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c460430"]])

export default __exports__